// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1UserCapacitySchema = z.object({
  id: z.number().int().describe("Capacity ID. Null for default capacity").nullish(),
  weekly_capacity: z.number().min(0).describe("Specifies the user's weekly hour capacity. The default is account's weekly capacity. Can only have a decimal place of .5 (e.g. 3.5 hours)"),
  daily_capacity: z.number().min(0).describe("Specifies the user's daily hour capacity"),
  weekdays: z.coerce.string().describe("Legacy weekday format. Example: *'MO,TU,WE,TH,FR'*").nullish(),
  work_days: z.coerce.string().describe("Comma-separated working days. Example: *'MON,TUE,WED,THU,FRI'*"),
  total_working_days: z.number().int().min(0).describe("Total working days in the capacity period. Null for open-ended capacities").nullish(),
  weekly_working_days: z.number().int().min(0).max(7).describe("Specifies the number of user's weekly working days"),
  current: z.boolean().describe("True if this is the active capacity (no end date)"),
  start_date: z.string().date().describe("ISO8601 start date"),
  end_date: z.string().date().describe("ISO8601 end date. Null for open-ended capacities").nullish(),
});
